import IOApi from '@/api/IOApi'
import LocationGroupApi from '@/api/LocationGroupApi/LocationGroupApi'
import AdvertiserApi from '@/api/AdvertiserApi'
import AccountApi from '@/api/account'
import { locationGroupType as LocationGroupType } from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/constants'

class PointGroupCatalog {
  static async getIOList(advertiserId) {
    const period = 'all'
    const minPermissionLevel = 'readonly'
    const ret = await IOApi.fetchIOList({
      advertiserId,
      minPermissionLevel,
      period,
    })
    const ioList = ret.items
    return ioList
  }
  static async getGroupList(
    ownerProfileId,
    locationGroupType = LocationGroupType.All,
  ) {
    const ret = await LocationGroupApi.fetchLocationGroupList(
      ownerProfileId,
      locationGroupType,
    )
    const groupList = ret.items
    return groupList
  }
  static async getAdvertiser(advertiserId) {
    const ret = await AdvertiserApi.fetchAdvertiser(advertiserId)
    const advertiser = ret.item
    return advertiser
  }
  static async getSystemOwner() {
    const ret = await AccountApi.getSystemOwner()
    const systemOnwer = ret
    return systemOnwer
  }
}

export default PointGroupCatalog
